import { render, staticRenderFns } from "./ElectricVehiclesConfig.vue?vue&type=template&id=494ad251"
import script from "./ElectricVehiclesConfig.vue?vue&type=script&lang=js"
export * from "./ElectricVehiclesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports